import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';


@Component({
  selector: 'app-nav-button',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './nav-button.component.html'
})
export class NavButtonComponent {
  @Input() active: boolean = false;
  @Input() label!: string;
  @Input() badge: number = 0;
  @Output() onClick = new EventEmitter<void>();
}
